export function reduceProductos(t, v) {
  return t + (v.price * v.quantity)
}